import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='estate-planning-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={
      <>
        What is <WidowBlock>estate planning&#63;</WidowBlock>
      </>
    }
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          No matter how large or how modest, everyone has an estate. And an estate plan simply makes sure that everything you own, and what you wish to have happen, when you&#39;re no longer able to do it yourself or when you pass away, is handled the way you want. We work with a team of estate planning experts to help you develop the best strategies so that your family won&#39;t be burdened by speculating on what you may <WidowBlock>have wanted.</WidowBlock>
        </Typography>
        <Link
          id='estate-planning-intro-section-get-started-link'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Get started with a financial advisor'>
          Get started
        </Link>
      </>
    )}
  />
);
